// Načítání virtuální prohlídky a videoprohlídky
const inicializedVideoPlayers = {};
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".view-player").forEach(el => {
        el.addEventListener("click", () => loadPlayer(el))
    })
});

function loadPlayer(el) {
    const {type, id} = el.dataset;
    if (typeof inicializedVideoPlayers[type] !== 'undefined') {
        return;
    }
    inicializedVideoPlayers[type] = true;
    const playerTypes = {
        video: () => createVideo(id)
    };
    if (playerTypes[type]) {
        el.innerHTML = "";
        el.appendChild(playerTypes[type]())
    }
}

function createVideo(src) {
    const video = document.createElement("video");
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    return video;
}